// ProductContext.js
import { createContext } from "react";
import { useState} from 'react';
import { isExpired } from 'react-jwt';


const ProductContext = createContext();

export function ProductProvider({ children }) {
  /* const [count, setCount] = useState(1);
  const [discount, setDiscount] = useState(0);
  const [name, setName] = useState("Banana");
  const [price, setPrice] = useState(2.99); */

  const token = sessionStorage.getItem('jwtToken'); // Retrieve JWT token from localStorage
    console.log('JWT token retrieved:', token);
    console.log('isExpired is:', isExpired(token));
    const [login, setLogin] = useState(null);
    const tokenExp = isExpired(token);

  const context = {
    token: token,
    tokenExp: tokenExp,
    login: login,
    setLogin: setLogin,
  };
  return (
    <ProductContext.Provider value={context}>
      {children}
    </ProductContext.Provider>
  );
}

export default ProductContext;
